import { RootPaths } from "@src/appV2/App/paths";

export const CLIPBOARD_SCORE_PATH = "clipboard-score";
export const CLIPBOARD_SCORE_FULL_PATH = `${RootPaths.APP_V2_HOME}/${CLIPBOARD_SCORE_PATH}`;

export const CLIPBOARD_SCORE_ADJUSTMENTS_PATH = "adjustments";
export const CLIPBOARD_SCORE_ADJUSTMENTS_FULL_PATH = `${CLIPBOARD_SCORE_FULL_PATH}/${CLIPBOARD_SCORE_ADJUSTMENTS_PATH}`;

export const CLIPBOARD_SCORE_HISTORY_PATH = "history";
export const CLIPBOARD_SCORE_HISTORY_FULL_PATH = `${CLIPBOARD_SCORE_FULL_PATH}/${CLIPBOARD_SCORE_HISTORY_PATH}`;

export const CLIPBOARD_SCORE_NEVER_NO_SHOW_MODAL_PATH = "never-no-show";
export const CLIPBOARD_SCORE_NEVER_NO_SHOW_FULL_PATH = `${CLIPBOARD_SCORE_FULL_PATH}/${CLIPBOARD_SCORE_NEVER_NO_SHOW_MODAL_PATH}`;

export const CLIPBOARD_SCORE_NO_SHOW_MODAL_PATH = "no-show";
export const CLIPBOARD_SCORE_WORKER_LEFT_EARLY_MODAL_PATH = "worker-left-early";

export const CLIPBOARD_SCORE_SHARE_PATH = "share";
export const CLIPBOARD_SCORE_SHARE_FULL_PATH = `${CLIPBOARD_SCORE_FULL_PATH}/${CLIPBOARD_SCORE_SHARE_PATH}`;
